import * as dayjs from 'dayjs';
import {IFilterListItem} from '../filter-list-item.model';
import { TimespanFilterValuesConstant } from '../../constants/timespan-filter-values.constant';

export interface IFlightsFilter {
  timespan?: keyof typeof TimespanFilterValuesConstant;
  station?: string;
  status?: string;
  alerts?: string;
  sortBy?: string;
  date?: Date;
  showUnpaired?: boolean;
  acRegistration?: string;
  flightNumber?: string;

  getListOfNonEmptyProperties(): IFilterListItem[];
}

export class FlightsFilter implements IFlightsFilter {
  timespan?: keyof typeof TimespanFilterValuesConstant;
  station?: string;
  status?: string;
  alerts?: string;
  sortBy?: string;
  date?: Date;
  showUnpaired?: boolean;
  acRegistration?: string;
  flightNumber?: string;


  constructor(val: IFlightsFilter) {
    this.timespan = val.timespan;
    this.station = val.station;
    this.status = val.status;
    this.alerts = val.alerts;
    this.sortBy = val.sortBy;
    this.date = val.date;
    this.showUnpaired = val.showUnpaired;
    this.acRegistration = val.acRegistration;
    this.flightNumber = val.flightNumber;
  }

  getListOfNonEmptyProperties(): IFilterListItem[] {
    let list: { name: string, operator: string, value: any }[] = [];

    if (this.timespan) {
      const timespanValue: readonly [number, number] = TimespanFilterValuesConstant[this.timespan];
      const from: dayjs.Dayjs = dayjs.utc().subtract(timespanValue[0], 'hours');
      const until: dayjs.Dayjs = dayjs.utc().add(timespanValue[1], 'hours');

      list = [
        {name: 'dateOfOperation', operator: '>=', value: from.toDate()},
        {name: 'dateOfOperation', operator: '<=', value: until.toDate()}
      ];
    }

    if (this.acRegistration?.length) {
      list.push({ name: 'acRegistration', operator: '==', value: this.acRegistration });
    }

    if (this.flightNumber?.length) {
      list.push({ name: 'flightNumber', operator: '==', value: this.flightNumber });
    }

    if (!this.showUnpaired) {
      list.push({name: 'groundTime', operator: '!=', value: 0});
    }

    if (this.station && this.station !== 'null') {
      list.push({name: 'airportCode', operator: '==', value: this.station});
    }

    if (this.status && this.status !== 'null') {
      list.push({name: 'status', operator: '==', value: this.status});
    }

    if (this.alerts && this.alerts !== 'null') {
      list.push({name: 'hasAlerts', operator: '==', value: this.alerts === 'true'});
    }
    /*
    if (this.sortBy && this.sortBy !== 'null') {
      list = [...list, {name: 'sortBy', operator: '==', value: this.sortBy}];
    } */

    return list;
  }

}
